import { useEffect, useState } from 'react';

function useError() {
    const [error, setError] = useState(null);

    useEffect(() => {
        if (error) {
            throw new Error(error)
        }
    }, [error])

    return {
        error,
        setError,
    };
}
export default useError;